import { render, staticRenderFns } from "./Rastreio.vue?vue&type=template&id=220d826d"
import script from "./Rastreio.vue?vue&type=script&lang=js"
export * from "./Rastreio.vue?vue&type=script&lang=js"
import style0 from "./Rastreio.vue?vue&type=style&index=0&id=220d826d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
